// API Configuration
export const API_CONFIG = {
  // Production URL (same domain)
  PRODUCTION_URL: '',
  
  // Development URL (localhost)
  DEVELOPMENT_URL: 'http://localhost:3001',
  
  // Get the appropriate URL based on environment
  getApiUrl(): string {
    // If VITE_API_URL is set, use it (for custom deployments)
    if (import.meta.env.VITE_API_URL) {
      return import.meta.env.VITE_API_URL;
    }
    
    // In development, use localhost
    if (import.meta.env.DEV) {
      return this.DEVELOPMENT_URL;
    }
    
    // In production, use relative path (same domain)
    return this.PRODUCTION_URL;
  }
};

// Export the API URL for use throughout the app
export const API_URL = API_CONFIG.getApiUrl(); 